
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IAppForm } from './IAppForm'
import { ApplicationModule, DataModule } from '@/store'

	@Component({
	  name: 'DrivingLicense'
	})
export default class DrivingLicense extends Vue implements IAppForm {
  // #region Props

		@Prop() wizardIndex!: number;

		// #endregion

		// #region Data

		get value () {
		  return ApplicationModule.form
		}

		accordionOpen = false;

		showError = false;

		// #endregion

		// #region Methods

		async submit () {
		  const valid = this.validate()

		  if (!valid) { return }

		  this.$emit('submit', this.wizardIndex)
		}

		validate () {
		  this.showError = false

		  if (!this.value.drivingLicence.id || this.value.drivingLicence.id <= 0) {
		    this.showError = true
		    return false
		  }

		  return true
		}

		previous () {
		  this.value.drivingLicence.id = ApplicationModule.formCopy.drivingLicence.id

		  this.$emit('previous')
		}

		setValue (val: number) {
		  this.value.drivingLicence.id = val
		  this.accordionOpen = !!(this.value.drivingLicence.id !== undefined && this.value.drivingLicence.id !== 35)
		  if (val > 0) {
		    setTimeout(() => { this.submit() }, 500)
		  }
		}

		// #endregion

		// #region Computed

		get licenseName () {
		  const obj = DataModule.drivingLicenses.find(v => v.value === this.value.drivingLicence.id)
		  return this.value.drivingLicence.id && obj ? obj.label : ''
		}

		get hasLicenceData () {
		  return [
		    { label: 'Yes', value: 35 },
		    { label: 'No', value: 0 }
		  ]
		}

		get fullLicenceTypeData () {
		  return [
		    { label: 'Provisional UK', value: 36 },
		    { label: 'EU', value: 37 },
		    { label: 'International', value: 39 },
		    { label: 'None', value: 38 }
		  ]
		}

		get idval () {
		  return this.value.drivingLicence.id
		}
		// #endregion

		// #region Watches

		@Watch('value.drivingLicence.id', { deep: true, immediate: true })
		async clearError () {
		  this.accordionOpen = !!(this.value.drivingLicence.id !== undefined && this.value.drivingLicence.id !== 35)

		  if (this.value.drivingLicence.id && this.value.drivingLicence.id > 0) {
		    this.showError = false
		  }
		}

  // #endregion
}
